var index = 0;
export var generateID = function generateID() {
  return index += 1;
};